module.exports = __webpack_public_path__ + "img/crm-en-ca.1e9ea0a1.jpg";